export default "__VITE_ASSET__DD0x7fij__"